'use client';

import Cookies from 'js-cookie';
import { useEffect } from 'react';

const COOKIE_NAME = 'sticky_phone_number_';
const DEFAULT = '8888880446';

export default function StickyPhoneNumber({ phoneNumber = DEFAULT }: { phoneNumber?: string }) {
  useEffect(() => {
    if (!Cookies.get(COOKIE_NAME)) Cookies.set(COOKIE_NAME, phoneNumber, { expires: 365 });
  }, [phoneNumber]);

  return null;
}
